import { ValueType } from "@/types/bid";

import CommonCheckbox from "@/components/Common/Checkbox";
import AccordionPanel from "@/components/AccordionPanel";

type Props = {
  title: string;
  data: ValueType[];
  defaultValue: string[];
  onChange: (value: string[]) => void;
};
export default function AccordionCheckboxPanel({
  title,
  data,
  defaultValue,
  onChange,
}: Props) {
  const isAllChecked = data.length === defaultValue.length;

  const handleAllChange = () => {
    if (isAllChecked) {
      onChange([]);
    } else {
      onChange(data.map((item) => item.value));
    }
  };
  const handleChange = (value: string) => {
    const newValue = defaultValue.includes(value)
      ? defaultValue.filter((v) => v !== value)
      : [...defaultValue, value];
    onChange(newValue);
  };

  return (
    <AccordionPanel title={title}>
      <div className="flex flex-col gap-2.5">
        <CommonCheckbox
          label="전체"
          defaultValue={isAllChecked}
          onChange={handleAllChange}
        />
        {data.map((item, index) => (
          <CommonCheckbox
            key={index}
            label={item.label}
            defaultValue={defaultValue.includes(item.value)}
            onChange={() => {
              handleChange(item.value);
            }}
          />
        ))}
      </div>
    </AccordionPanel>
  );
}
